export default {
  primary: 'primary',
  success: 'green',
  error: 'red',
  warning: 'orange',
  orange: 'orange',
  'neutral-lighter': '#dee5ed',
  default: '#ffffff'
};
